import { jsonp } from '@ifeng-fe/ui_base';
import { getUserid, getUserkey, getOs } from '../utils/utils';

const md5 = require('@ifeng-fe/md5');
const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
const apiBaseUrl = apiUrl;
// const apiBaseUrl = 'http://test0.web-pages-content.shank.ifeng.com/c';
/* eslint-enable no-undef */

export const allLookData = async (config, type = 'article') => {
    if (!config) {
        config = {};
    }

    const aid = config.aid;
    const title = config.title;

    const data = await jsonp(`//c2.m.ifeng.com/newShareDocRelates?aid=${aid}&title=${title}&type=${type}`, {
        cache: false,
    });
    let result = '';

    if (data && data.length !== 0) {
        result = data;
    }

    return result;
};

/**
 * 视频分享页获取信息流
 * @param {*} guid 视频id
 * @param {*} title 视频标题
 * @param {*} os 用户设备
 * @param {*} uid 用户uid
 * @param {*} page 当前页
 * @param {*} pagesize 一页条数
 * @returns {Array} result
 */
export const videoShareNewsSream = async (guid, title, os, uid, page, pagesize, seo) => {
    const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
    const proid = isVideoShare ? 'ifengvideoh5' : 'ifengnewsh5';

    return await jsonp(
        `${apiBaseUrl}/api/videoShare/getrecnewslist/${seo}/${guid}/${encodeURIComponent(
            title.replace(/[/|?]/g, '', ''),
        )}/${os}/${uid}/${page}/${pagesize}/${proid}/getVideoShareNewStream`,
        {
            jsonpCallback: 'getVideoShareNewStream',
            cache: false,
        },
    );
};

export const getNewsAppVideoRec = async (title, guid) => {
    const userId = getUserid() || `null_share_relate_${Date.parse(new Date())}`;
    const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
    const proid = isVideoShare ? 'ifengvideoh5' : 'ifengnewsh5';

    return await jsonp(
        `${apiBaseUrl}/api/videoShare/getRecomVideosList/${encodeURIComponent(
            title.replace(/[/|?]/g, '', ''),
        )}/${guid}/${userId}/${proid}/getrecvideoscb`,
        {
            jsonpCallback: 'getrecvideoscb',
            cache: false,
        },
    );
};

export const getUaParser = async (uaHash) => {
    const result = await jsonp(`https://shankapi.ifeng.com//feedflow/uadevice/${uaHash}/getUaParserCallback`, {
        jsonpCallback: 'getUaParserCallback',
    });

    return result.data;
};

// 获取标题和选集内容
export const getCollectVideo = async (id, crowdid) => {
    const result = await jsonp(`${apiBaseUrl}/api/videoShare/getCollectVideo/${id}/${crowdid}/collectVideosCallback`, {
        jsonpCallback: 'collectVideosCallback',
        cache: false,
    });

    if (result && result.data && result.data.id) {
        return result.data;
    } else {
        return '';
    }
};

/**
 * 推荐视频
 * @param {Object} config
 * @param {String} type
 */
export const getSpecificList = async (id, from, n) => {
    const data = await jsonp(
        `https://nine.ifeng.com/relateshare?id=${id}&page=1&n=${n}&uid=${getUserkey()}&gv=7.27.0&proid=ifengnewsh5&os=${getOs()}&type=video&from=${from}`,
        {
            cache: false,
        },
    );

    let result = [];

    if (data && data.code === 0 && data.data && data.data.length > 0) {
        result = data.data;
    }

    return result;
};

/**
 * 获取ucms文章相关推荐数据列表
 * @param {array} base64List
 */
export const getRelateFeedList = async (base64List = []) => {
    let result = [];

    if (base64List.length === 0) return result;
    const base64String = base64List.join(',');
    const getRelateFeedList = createJsonpCallbackName('getRelateFeedList');
    const data = await jsonp(
        `https://shankapi.ifeng.com/feedflow/getFeedflowListByUcmsIds/${base64String}/${getRelateFeedList}`,
        {
            jsonpCallback: getRelateFeedList,
            cache: false,
        },
    );

    if (data && data.code === 0 && data.data && data.data.length > 0) {
        result = data.data;
    }

    return result;
};

// 获取视频分享页获取话题热榜前三条
export const getHotThemeList = async () => {
    let result = [];

    try {
        const { code, data } = await jsonp(`${apiBaseUrl}/api/videoShare/getHotThemeList/hotThemeListCallback`, {
            jsonpCallback: 'hotThemeListCallback',
            cache: false,
        });

        if (code === 0 && data && Array.isArray(data)) {
            result = data;
        }
    } catch (e) {
        console.error(e);
    }

    return result;
};

// 卫视原生栏目详情页
export const getPhtvSoleNewsList = async (id, year, page) => {
    try {
        const data = await jsonp(
            `${apiBaseUrl}/api/videoShare/phtvSoleNewsList/${id}/${page}/${year}/phtvSoleNewsListCallback`,
            {
                jsonpCallback: 'phtvSoleNewsListCallback',
                cache: false,
            },
        );

        if (data.code === 0 && data.data && data.data.chConfig) {
            return data.data;
        }

        return {};
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取短视频评论数
 * @param {string} base64
 */
export const getShortVideoCommentNum = async (base64) => {
    let result = {};
    const getShortCommentNum = createJsonpCallbackName('getShortCommentNum');
    const data = await jsonp(`https://comment.ifeng.com/get?job=4&special=0&format=js&docUrl=${base64}`, {
        jsonpCallback: getShortCommentNum,
        cache: false,
    });

    if (data && data[0]) {
        result = data[0];
    }

    return result;
};

/**
 * 获取短视频赞数量
 * @param {string} base64
 */
export const getShortVideoPraiseNum = async (base64) => {
    let result = 0;
    const getShortVideoPraiseNum = createJsonpCallbackName('getShortVideoPraiseNum');
    const data = await jsonp(`https://survey.news.ifeng.com/api/getaccumulator?key%5B0%5D=${base64}ding&format=js`, {
        jsonpCallback: getShortVideoPraiseNum,
        cache: false,
    });

    if (data?.data?.browse && data?.data?.browse[`${base64}ding`]) {
        result = data?.data?.browse[`${base64}ding`];
    }

    return result;
};

/**
 * 短视频推荐视频
 * @param {Object} config
 * @param {String} type
 */
export const getShortVideoRecom = async (id, userkey) => {
    const data = await jsonp(
        `https://nine.ifeng.com/minivideosharelist?pullNum=1&pullTotal=2&ts=2022-05-25%2011%3A56%3A27&gv=7.44.0&av=0&proid=ifengnews&os=ios_15.4.1&df=iPhone12%2C1&vt=5&screen=828x1792&publishid=4002&uid=${userkey}&videoId=${id}&uid2=2aa625346b5e4b7e831053a810defa34&nw=wifi&loginid=97018491&token=CF5F852FDC2E1AC0457BF472E50B9E5E&st=16534509875545&sn=50468dbec92d60f4a91b80baf5ce60b5&action=default`,
        {
            cache: false,
        },
    );

    let result = [];

    if (data && data.code === 0 && data.data && data.data.length > 0) {
        result = data.data;
    }

    return result;
};

/**
 * 短视频分享页获取评论
 */
export const getShortVideoShareComments = async ({ doc_url, p, pagesize = 40 }) => {
    const callbackName = 'getShortVideoShareCommentsCallback';

    return jsonp(
        `https://comment.ifeng.com/v3/get/comments?doc_url=${doc_url}&p=${p}&pagesize=${pagesize}&format=js&gv=h5`,
        {
            cache: false,
            jsonpCallback: callbackName,
        },
    );
};

// 卫视放映厅1
export const getTvHall1Data = async () => {
    const data = await jsonp('https://shankapi.ifeng.com/api/content/share/hitTv1Callback', {
        jsonpCallback: 'hitTv1Callback',
        cache: false,
    });

    let result = [];

    if (data?.code === 0 && data?.data?.length > 0) {
        result = data.data;
    }

    return result;
};

// 卫视放映厅2
export const getTvHall2Data = async () => {
    const data = await jsonp('https://shankapi.ifeng.com/api/content/share/hitTv2Callback', {
        jsonpCallback: 'hitTv2Callback',
        cache: false,
    });

    let result = {};

    if (data?.code === 0 && data?.data?.title) {
        result = data.data;
    }

    return result;
};

export const getReadNumWeight = async (id, publishTimeStamp, serviceid = 5) => {
    const data = await jsonp(
        `https://survey.news.ifeng.com/api/getaccumulatorweight?key=sharePageRead_${id}&serviceid=${serviceid}&format=js&createtime=${publishTimeStamp}`,
        {
            jsonpCallback: 'getReadNumWeight',
            cache: false,
        },
    );

    let result = 0;

    if (data?.code === 1 && data?.data?.browse?.[`sharePageRead_${id}`]) {
        result = data.data.browse[`sharePageRead_${id}`];
    }

    return result;
};

export const getReadNumNormal = async (id, publishTimeStamp, serviceid = 5) => {
    const data = await jsonp(
        `https://survey.news.ifeng.com/api/getaccumulator?key=sharePageRead_${id}&serviceid=${serviceid}&format=js&createtime=${publishTimeStamp}`,
        {
            jsonpCallback: 'getReadNumNormal',
            cache: false,
        },
    );

    let result = 0;

    if (data?.code === 1 && data?.data?.browse?.[`sharePageRead_${id}`]) {
        result = data.data.browse[`sharePageRead_${id}`];
    }

    return result;
};

export const setReadNum = async (id, publishTimeStamp) => {
    const data = await jsonp(
        `https://survey.news.ifeng.com/api/accumulator?key=sharePageRead_${id}&format=js&createtime=${publishTimeStamp}`,
        {
            jsonpCallback: 'setReadNum',
            cache: false,
        },
    );

    let result = 0;

    if (data?.code === 1 && data?.data?.browse?.[`sharePageRead_${id}`]) {
        result = data.data.browse[`sharePageRead_${id}`];
    }

    return result;
};

// 获取视频播放数
export const getVideoComment = async (vid) => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (vid.length > 0) {
        vid.forEach((item) => {
            apiUrl += `key[]=${item}&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 1,
        },
        jsonpCallback: 'getVideoComment1',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};

// 获取广告回退hash值
export const getBackUrl = async (keywords, type = 'video') => {
    const hisHotRankUrl = `https://ishare.ifeng.com/hotNewsRank?from=share&type=${type}`;

    if (!navigator.userAgent.toLocaleLowerCase().includes('micromessenger')) {
        return hisHotRankUrl;
    }
    const callback = createJsonpCallbackName('getAdvertHash');
    const defaultHash = 'f71ca736c1728446a1c01cbb6efafaaa';
    const hotRankHash = 'd41d8cd98f00b204e9800998ecf8427e';
    const data = await jsonp(
        `https://ishare.ifeng.com/api/share/pageHash/${new Date().getTime()}/${callback}?keywords=${encodeURIComponent(
            keywords,
        )}`,
        {
            jsonpCallback: callback,
            cache: false,
        },
    );
    const apiHash = data?.data?.hash || '';

    if (navigator.userAgent.toLocaleLowerCase().includes('micromessenger')) {
        if (hotRankHash === apiHash || defaultHash === apiHash) {
            return hisHotRankUrl;
        }

        if (apiHash) {
            return `https://ishare.ifeng.com/api/share/redirect/${apiHash}?type=${type}`;
        } else {
            return hisHotRankUrl;
        }
    }
};
